import React from 'react';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    IconButton,
    Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQProps {
    faqData: FAQItem[];
}




export const FAQ: React.FC = () => {
    const faqData = [
        { question: 'Why do I have to provide my medical records to enroll in a clinical trial?', answer: 'To enroll in clinical trial, you must meet highly specific criteria that’s established by the researchers who are conducting the investigation. That includes detailed information about type of cancer, treatment history, response to treatment, and other data that is collected in medical records.' },
        { question: "What should I do if I don't have my medical records?", answer: 'If you are being treated for cancer or any other disease, your doctor should have a complete record of your medical care, including specific information about what form of the disease you have and what treatments you have received. Your patient relations coordinator will contact you and inform you about the details.' },
        { question: "What are the costs associated with Massive Bio's services?", answer: 'Massive Bio provides its services to the patients and their doctors at no cost—you won’t have to pay anything to receive a clinical-research matching report. There are no hidden costs involved.' },
        { question: "How does Massive Bio protect my personal information?", answer: 'Massive Bio strictly adheres to all HIPAA guidelines and international regulations focused on maintaining your privacy. We take extra measures to secure your personal information, ensuring it is protected beyond the mandatory requirements.' },
        { question: "Where can I find clinical research studies in my area?", answer: 'Your doctor may know of a clinical research study being conducted in your area that’s recruiting participants and is right for you. However, Massive Bio uses its artificial intelligence powered platform to match patients to clinical research studies that give you the best chance of a positive outcome and are being conducted in a geographical location that makes sense for you.' },
        { question: "Can I continue seeing my doctor or oncologist while also taking services of Massive Bio?", answer: 'Yes, Massive Bio keeps your doctor up to date on your status throughout your participation.' },

    ];

    //   const topFAQ = {
    //     question: 'Are there any current promotions?',
    //     answer: 'Yes, we currently have a 20% off sale on all summer items...',
    //   };

    return (
        <Box width="100%" sx={{ margin: 0, padding: 0 }}>
            <Typography variant="h5"
                sx={{
                    fontWeight: 'bold',
                    mb: 2,
                    mt: 4
                }} gutterBottom>
                Frequently asked questions
            </Typography>
            {
                faqData.map((item, index) => (
                    <Box sx={{ backgroundColor: 'lightgray', border: 0, borderRadius: 3, background: 'lightgray', padding: .5, mb: 1 }} key={index}>
                        <Accordion  elevation={0} key={index} sx={{ m: 1, backgroundColor: '#6495ED',}}>
                            <AccordionSummary sx={{ padding: '8px 16px',  backgroundColor: 'lightgray', }}
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls={`panel${index + 1}-content`}
                                id={`panel${index + 1}-header`}
                            >
                                <Typography>{item.question}</Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={{  backgroundColor: 'lightgray', }}>
                                <Typography>{item.answer}</Typography>
                            </AccordionDetails>
                        </Accordion>
                    </Box>
                ))}
        </Box>
    );
};

interface TopFAQProps {
    question: string;
    answer: string;
    onClose: () => void;
}

export const TopFAQComponent: React.FC<TopFAQProps> = ({ question, answer, onClose }) => {
    return (
        <Accordion defaultExpanded>
            <AccordionSummary
                expandIcon={null}
                aria-controls="top-panel-content"
                id="top-panel-header"
            >
                <Typography flexGrow={1}>{question}</Typography>
                <IconButton aria-label="close" onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </AccordionSummary>
            <AccordionDetails>
                <Typography>{answer}</Typography>
            </AccordionDetails>
        </Accordion>
    );
};